import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getCharlotteStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in Charlotte", "/locations/restore-charlotte/", clinicsIn("charlotte")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Charlotte", path: "/locations/restore-charlotte/" },
    ]),
  ];
}
